import { useSelector } from "react-redux";
import theme from "../config/theme";

interface AccountCartProps {
    active: number;
    deactive: number;
    Icon?: any;
    name?: string;
}

export default function AccountCart({
    active,
    deactive,
    Icon,
    name,
}: AccountCartProps) {
    const themeMode = useSelector((state: any) => state.globalState.theme);
    const mode = themeMode === "light" ? theme.light : theme.dark;
    return (
        <div
            className="flex flex-row w-full justify-between items-center px-6 md:py-3 py-2 bg-white shadow rounded-lg border border-[#ababab] overflow-hidden hover:shadow-[0_0px_6px_#03797d73]"
            style={{
                backgroundColor: mode.backgroundColor.bgSecondary,
                color: mode.color.textPrimary,
            }}
        >
            <div className="flex flex-col items-center space-y">
                <div className="text-2xl font-bold tracking-tight leading-none text-blue-400">
                    <div className="flex items-center justify-center  gap-x-2">
                        <span className="text-[25px]">{active || 0}</span>
                        <span
                            className="text-[18px] text-[#AAAAAA]"
                            style={{
                                display: !deactive ? "none" : "inline-block",
                            }}
                        >
                            +
                        </span>
                        <span
                            className="text-[18px] text-[#AAAAAA]"
                            style={{
                                display: !deactive ? "none" : "inline-block",
                            }}
                        >
                            {deactive || 0}
                        </span>
                    </div>
                </div>
                <div className="text-lg  ">{name}</div>
            </div>
            <Icon className="w-12 h-12" />
        </div>
    );
}
